import React, { forwardRef, type ElementType, type HTMLAttributes } from 'react';
import styles from './Logo.module.css';
 
// Static imports for CRA compatibility (import.meta.glob is Vite-only)
// Using ReactComponent imports for SVGs
// import { ReactComponent as BrandingHs } from '../../../assets/logo/branding-hs.svg';
// import { ReactComponent as BrandingMayo } from '../../../assets/logo/branding-mayo.svg';
// import { ReactComponent as BrandingConnect } from '../../../assets/logo/branding-connect.svg';
 
/*
 * Logo — asset primitive (flat brand set)
 *
 * See CATALOG. One primary brand mark per Heidrick tenant, rendered inline
 * at its intrinsic Figma dimensions:
 *   <Logo brand="hs" title="Heidrick & Struggles" />   208×11 wordmark, #334255
 *   <Logo brand="mayo" title="Mayo Clinic" />           39×48 shield, #1A212E
 *   <Logo brand="connect" title="Heidrick Connect" />   208×15 wordmark, navy + teal
 *
 * Brand colors are preserved verbatim in the SVG — NOT theme-bound — per the
 * Icon.Social multi-color-brand-mark doctrine. Connect is two-tone and
 * cannot collapse to a single currentColor.
 *
 * Adding/replacing a brand mark: drop the SVG at src/assets/logo/branding-<brand>.svg
 * and add a ReactComponent import + registry entry below.
 */
// const registry: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
//   hs: BrandingHs,
//   mayo: BrandingMayo,
//   connect: BrandingConnect,
// };
 
/** Tenant brand keys — derived from the brand marks shipped in src/assets/logo/. */
export type LogoBrand = 'hs' | 'mayo' | 'connect' | string;
 
export interface LogoProps extends HTMLAttributes<HTMLSpanElement> {
  /** Which tenant's brand mark to render. */
  brand: LogoBrand;
  /** Accessible name. Supplied → role="img" + aria-label (informative);
   *  omitted → aria-hidden="true" (decorative). */
  title?: string;
  /** Render the root as a different element/component. Default `'span'`. */
  as?: ElementType;
}
 
export const Logo = forwardRef<HTMLSpanElement, LogoProps>(
  function Logo({ brand, title, className, as, ...rest }, ref) {
  // const SvgComponent = registry[brand];

  // if (!SvgComponent) {
  //   if (typeof console !== 'undefined') {
  //     console.warn(`[Logo] missing asset: logo/branding-${brand}.svg`);
  //   }
  //   return null;
  // }
 
  const Component = as ?? 'span';
  const wrapperClass = [styles.logo, className].filter(Boolean).join(' ');
  const a11y = title
    ? { role: 'img' as const, 'aria-label': title }
    : { 'aria-hidden': true as const };
 
  return (
    <Component
      ref={ref}
      className={wrapperClass}
      {...a11y}
      {...rest}
    >
      {/* <SvgComponent /> */}
      <img className="dynamicHeaderLogo" alt="header icon" src={brand} />
    </Component>
  );
  },
);
 
Logo.displayName = 'Logo';